import React from 'react';

// This helper component will allow external links to be open in a new window,
// so that user isn't taken away from the experience.
// FYI - there's a bug with mailto: links not opening new window in Firefox
// https://bugzilla.mozilla.org/show_bug.cgi?id=646552
export const PopOpenLink: React.FC<React.HTMLProps<HTMLAnchorElement>> = (
  props,
) => <a target="_blank" rel="nofollow noopener" {...props}></a>;
